<div class="form-subcontainer">
  <div class="form-content">
    <div>
      <form
      formName="requstCheque"
        [formGroup]="formGroup"
        (ngSubmit)="confirm()"
        class="fpx-form-group"
      >
       
        <section
          id="accSec"
          class="account-sec"
          [ngClass]="{ accDisabled: accDisable }"
        >
          <h3 class="fpx-sec-title">
            {{ "CHEQUEBOOKREQ.header" | translate }}
          </h3>
          <app-account-list
            formControlName="accountNumber"
            [accType]="accType"
            [disabled]="state.disableMode"
          ></app-account-list>
        </section>

        <section class="request-details-sec">
          <h3 class="fpx-sec-title">
            {{ "CHEQUEBOOKREQ.subHeader" | translate }}
          </h3>
          <div class="details-entry-panel">
            <!-- <div class="fpx-field">
              <app-test-rdbtn
                label="TestBtn"
                formControlName="testBtn"
              ></app-test-rdbtn>
            </div> -->

            <div class="fpx-field">
              <app-num-cheque-book
                label="{{ 'CHEQUEBOOKREQ.numOfChequeBooks' | translate }}"
                formControlName="noOfChqBooks"
              ></app-num-cheque-book>
            </div>

            <div class="fpx-field">
              <app-num-leaves
                label="{{
                  'CHEQUEBOOKREQ.numOfLeavePerChequeBooks' | translate
                }}"
                formControlName="noOfLeaves"
              ></app-num-leaves>
            </div>

            <div class="fpx-field">
              <app-delivery-options
                label="{{ 'CHEQUEBOOKREQ.deliveryOptions' | translate }}"
                direction="row"
                labelPosition="after"
                formControlName="dlvryOption"
              ></app-delivery-options>
            </div>
            <div class="fpx-field">
              <app-branches
                label="{{ 'CHEQUEBOOKREQ.deliveryBranch' | translate }}"
                formControlName="dlvryBranch"
                [bankCodeEditValue]="'FIEGEGCXXXX'"
                [changePublisher]="formChangePublisher$"
              ></app-branches>
            </div>

            <div class="fpx-field">
              <app-remarks
                label="{{ 'CHEQUEBOOKREQ.remarks' | translate }}"
                formControlName="remarks"
              ></app-remarks>
            </div>

            <div [hidden]="requestReference" class="center-main">
              <ng-container *ngIf="!formGroup.disabled; else confirmTemplate">
                <section class="from-button-sec">
                  <button class="btn-link" (click)="reset()">
                    <span>{{ "FORM_ACTIONS.reset" | translate }}</span>
                  </button>
                </section>

                <section class="from-button-sec">
                  <button
                    type="button"
                    (click)="submit()"
                    class="button-common button40 active"
                    [disabled]="formGroup.invalid"
                  >
                    <span>{{ "FORM_ACTIONS.submit" | translate }}</span>
                  </button>
                </section>
              </ng-container>

              <ng-template #confirmTemplate>
                <section class="from-button-sec">
                  <button class="btn-link" (click)="edit()">
                    <span>{{ "FORM_ACTIONS.edit" | translate }}</span>
                  </button>
                </section>

                <section class="from-button-sec">
                  <button
                    type="submit"
                    class="button-common button40 active"
                    [disabled]="formGroup.invalid"
                  >
                    <span>{{ "FORM_ACTIONS.confirm" | translate }} </span>
                  </button>
                </section>
              </ng-template>
            </div>
          </div>
        </section>
      </form>
    </div>
  </div>
</div>
